import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";

export function getIsGwp10027NonprofitPricingPage() {
    return checkFeatureFlagGate(featureFlags.gwp10027NonprofitPricingPage);
}
